import React, { useEffect, useState } from "react";
import { HelpCircle, PlusCircle } from "react-feather";
import { AddOperacaoModal } from "../../../../Components/AddOperacaoModal";
import { Alert } from "../../../../Components/Error/Alert";
import { Header } from "../../../../Components/Header";
import { MenuLateral } from "../../../../Components/MenuLateral/Index";
import { ModalLoader } from "../../../../Components/ModalLoader";
import { Panel } from "../../../../Components/Panel";
import { TablePanel } from "../../../../Components/TablePanel";
import { useCartorio } from "../../../../Hooks/cartorio";
import { useFuncionarioCartorio } from "../../../../Hooks/funcionarioCartorio";
import { useOperacao } from "../../../../Hooks/operacoes";
import { AddOperacaoButton, Container } from "./styles";

export function Operacoes() {
  const { cartorio, checarToken, cartorioIsLogged } = useCartorio();
  const {
    funcionarioCartorio,
    checarTokenFuncionario,
    funcionarioCartorioIsLogged,
  } = useFuncionarioCartorio();
  const [operacaoModal, setOperacaoModal] = useState(false);
  const { getOperacoes, operacoes } = useOperacao();
  const [error, setError] = useState({ message: "", title: "" });
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    console.log(operacoes);
  }, [operacoes]);
  const [abas, setAbas] = useState([
    {
      title: "OPERAÇÕES",
      index: 1,
      execute: () => {},
      data: operacoes,
    },
  ]);

  async function handleGetOperacoes() {
    setLoading(true);

    try {
      if (cartorioIsLogged) {
        await checarToken();
      }
      if (funcionarioCartorioIsLogged) {
        await checarTokenFuncionario();
      }
      await getOperacoes(cartorio.ID);
    } catch (error) {
      setError({
        title: "Ops",
        message:
          "Não foi possível carregar suas operações. Tente novamente mais tarde!",
      });
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    handleGetOperacoes();
  }, [cartorio.ID]);

  return (
    <Container>
      <MenuLateral titulo={cartorio.NOME} />
      <Panel
        children={
          <>
            <Header type={"OPERAÇÕES"} />
            <TablePanel
              loading={loading || operacaoModal}
              abas={abas}
              index={1}
              operacoes={operacoes}
              tableHeader={["CÓDIGO", "DESCRIÇÃO"]}
              imoveis={false}
            />

            <AddOperacaoButton
              onClick={() => {
                setOperacaoModal(true);
              }}
            >
              <PlusCircle size={"max(18px, 1.8vw)"} />
            </AddOperacaoButton>
          </>
        }
      />
      <ModalLoader loading={loading} />
      <Alert
        title={error.title}
        message={error.message}
        open={error.message.length > 0}
        onClose={() => {
          setError({ title: "", message: "" });
        }}
      />
      <AddOperacaoModal
        open={operacaoModal}
        onClose={() => setOperacaoModal(false)}
      />
    </Container>
  );
}
